<script>

import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {

  data: function() {
    return {
    //   parameters: {},
    //   dom: false,
    //   loading: false,
    //   hasContent: false,
    //   currentFilter: 'all',
    //   //isInView: false,
    //   filters: [
    //     'all',
    //     'exteriors',
    //     'kitchens',
    //     'bedrooms',
    //     'bathrooms',
    //     'living',
    //     'other',
    //     'videos'
    //   ]
    };
  },

  props: {
    options: {},
    openModal: {},
    communityId: false,
    communityModal: Function,
    //modalOpen: {},
    closeModal: {},
    isInView: false,
  },

  mounted: function() {
    // this.loading = true;
    // // this.getImages();
    // this.$eventsBus.$on('gallery-set-filter', $params => {
    //   this.currentFilter = $params;
    // });
  },

  methods: {
    ...mapActions({
        put: 'slick/put',
        videoPut: 'modal/put'
    }),
    // getImages: function(filter = '') {
    //   Tortilla.Xhr.get(
    //     '/api/community-gallery/' + this.communityId + encodeURIComponent(filter), 
    //     this.parameters
    //   ).then(this.setImagesContent);
    // },
    // setImagesContent: function(result) {
    //     this.dom = result.data.renderedList;
    //     this.loading = false;
    //     this.hasContent = true;
    //     this.$nextTick(()=> {
    //         this.attachCardListeners();
    //     })
    // },
    communityImageModal: function(index) {
        this.$eventsBus.$emit('open-modal', ['modal-community-gallery', { index: index }]); 
        this.$nextTick(function() {
            this.put({key: 'modalImageIndex', value: index});
        });
        //this.modalOpen = true;
    },
    // attachCardListeners: function() {
    //     $('.community-gallery-image').on('click', (e)=> {
    //         e.stopPropagation();
    //         const params = $(e.currentTarget).data('open-community-modal');
    //         this.communityModal(params);
    //     });
    // }
  }
};

</script>


// WEBPACK FOOTER //
// resources/components/apps/community-gallery-images.vue